import { instanceUpload, errorService } from '@/services/api'
import { projectAPIs } from '@/services/authConstantsV1'
import _ from 'lodash'
import { AgGridVue } from 'ag-grid-vue'
import { showNotification } from '@/services/calculate'
import { socketEvents } from '@/services/config'
import ToolTipRenderer from '@/components/DynamicComponents/Renderers/tooltipRenderer'
import ValidationRenderer from '@/components/DynamicComponents/Renderers/validationRenderer'

export default {
  components: {
    'ag-grid-vue': AgGridVue,
  },
  props: [
    'uploadedFile',
    'name',
    'columnDefs',
    'projectId',
    'assetId',
    'buildingGeneralId',
    'url',
    'analysisTypeId',
  ],
  data: function() {
    return {
      visible: false,
      process: false,
      data: null,
      duration: 0,
      datafromSocket: null,
      processContent: `Your request for uploading ${this.name} will be processed shortly...`,
      updateList: [],
      selectedRowData: [],
      gridOptions: null,
      gridApi: null,
      defaultColDef: null,
      tableParams: null,
      width: '100%',
      height: '400px',
      loading: false,
      addedCount: 0,
      updatedCount: 0,
      failedCount: 0,
      validationError: false,
      modalWidth: '70rem',
      padding: '0px',
    }
  },
  created: function() {
    this.$root.$on('message-received', this.messageReceived)
  },
  beforeMount() {
    this.loadingConfig()
    window.addEventListener('resize', this.detectViewPortListener)
  },
  beforeDestroy() {
    this.$root.$off('message-received')
  },
  mounted() {
    this.importFile()
  },
  methods: {
    handleCancel() {
      this.visible = false
      this.duration = null
      this.selectedRowData = []
      this.validationError = false
      this.displayNotification()
      this.$emit('clickedCancel', this.addedCount)
    },

    importFile() {
      this.$notification.info({
        message: 'Import Request',
        description: (
          <div>
            <div>
              Your request for importing {this.name} will be processed shortly.
            </div>
            <div>You will be notified once the request is completed</div>
          </div>
        ),
        duration: 5,
      })
      const formdata = new FormData()
      formdata.append('file', this.uploadedFile)
      let url = this.url
        ? this.url
        : projectAPIs.project.asset.buildingGeneral.tenant.import(
          this.projectId,
          this.assetId,
          this.buildingGeneralId,
        )
      if (this.analysisTypeId === 2) {
        url = projectAPIs.project.asset.newConstbuildingGeneral.tenant.import(
          this.projectId,
          this.assetId,
          this.buildingGeneralId,
        )
      }
      instanceUpload
        .post(url, formdata)
        .then(response => {
          this.$notification.destroy()
          if (response.data.message) {
            showNotification('info', 'Import', response.data.message)
          }
        })
        .catch(err => {
          errorService(err)
        })
    },

    saveData() {
      this.$emit('updateBulkTenant', this.selectedRowData)
    },

    onRowSelected(event) {
      const selectedNodes = this.gridOptions.api.getSelectedNodes()
      const selectedData = selectedNodes.map(node => node.data)
      this.selectedRowData = selectedData
    },

    onSelectionChanged(event) {
      const selectedNodes = this.gridOptions.api.getSelectedNodes()
      const selectedData = selectedNodes.map(node => node.data)
      this.selectedRowData = selectedData
    },

    getData(params) {
      this.selectedRowData = []
      this.gridApi = this.gridOptions.api
      params.api.setColumnDefs(this.columnDefs)
      params.api.sizeColumnsToFit()
      this.tableParams = params
      const element = document.querySelector('#' + 'projectdetails')
      if (element) {
        this.height =
          Math.round(element.getBoundingClientRect().height) - 160 + 'px'
      }
    },

    loadingConfig() {
      this.gridOptions = {
        alwaysShowVerticalScroll: true,
        alwaysShowHorizontalScroll: true,
        headerHeight: 30,
        suppressRowClickSelection: true,
        singleClickEdit: true,
        stopEditingWhenGridLosesFocus: true,
        rowSelection: 'multiple',
        suppressContextMenu: true,
        rowHeight: 28,
        defaultColDef: {
          sortable: false,
          suppressMovable: true,
          menuTabs: [],
        },
        getRowHeight: this.getRowHeight,
      }

      this.frameworkComponents = {
        toolTipRenderer: ToolTipRenderer,
        validationRenderer: ValidationRenderer,
      }
    },

    getRowHeight(params) {
      if (
        params.node.data.validationMessage &&
        params.node.data.validationMessage.length > 0
      ) {
        return 28 * params.node.data.validationMessage.length
      } else {
        return 28
      }
    },

    displayNotification() {
      let description = null
      if (
        this.addedCount > 0 &&
        this.selectedRowData.length > 0 &&
        this.updatedCount > 0 &&
        this.failedCount === 0
      ) {
        description = `${this.name} is imported successfully. ${this.addedCount} new records added and ${this.updatedCount} records updated successfully.`
        showNotification('success', 'Import', description)
      }
      if (
        this.addedCount > 0 &&
        this.selectedRowData.length > 0 &&
        this.updatedCount > 0 &&
        this.failedCount > 0
      ) {
        description = `${this.name} is imported successfully. ${this.addedCount} new records added and ${this.updatedCount} records updated successfully.`
        showNotification('success', 'Import', description)
      }
      if (
        this.selectedRowData.length > 0 &&
        this.updatedCount > 0 &&
        this.failedCount === 0
      ) {
        description = `${this.name} is imported successfully. ${this.updatedCount} records updated successfully.`
        showNotification('success', 'Import', description)
      }
      if (
        this.selectedRowData.length > 0 &&
        this.updatedCount > 0 &&
        this.failedCount > 0
      ) {
        description = `${this.name} is imported successfully. ${this.updatedCount} records updated successfully. ${this.failedCount} records failed to update`
        showNotification('success', 'Import', description)
      }
      if (
        this.selectedRowData.length > 0 &&
        this.updatedCount === 0 &&
        this.failedCount > 0
      ) {
        description = `${this.failedCount} records failed to update`
        showNotification('success', 'Import', description)
      }
      if (this.addedCount > 0) {
        description = `${this.name} is imported successfully. ${this.addedCount} new records added successfully.`
        showNotification('success', 'Import', description)
      }
    },

    detectViewPortListener() {
      if (window.innerWidth > 1450) {
        this.width = '70rem'
        this.padding = '0px !important'
      } else if (window.innerWidth < 1450) {
        this.width = '100%'
        this.padding = '10px !important'
      } else {
        this.width = '70rem'
        this.padding = '0px !important'
      }
    },

    // Socket listen
    messageReceived: function(message, assetId, type) {
      this.loading = false
      this.$notification.destroy()
      const data = JSON.parse(message.message)
      if (data.EventType === socketEvents.fileImported) {
        if (type === 'newConstruction') {
          if (this.assetId === assetId) {
            if (data.Status === 'SUCCESS') {
              if (data.Result && this.analysisTypeId !== 2) {
                this.updateList = []
                const list = _.get(data.Result, 'UpdateList', [])
                this.addedCount = _.get(data.Result, 'AddedCount', 0)
                if (list.length > 0) {
                  list.forEach(element => {
                    this.updateList.push({
                      id: element.Id,
                      tenantName: element.TenantName,
                      suite: element.Suite,
                      tenantTypeId: element.TenantTypeId,
                      tenantType: element.TenantType,
                      tenantSF: element.TenantSF,
                    })
                  })
                  this.visible = true
                } else if (this.addedCount > 0) {
                  this.$notification.success({
                    message: 'Import',
                    description: h => (
                      <div>
                        <div>
                          <b>
                            {this.addedCount} / {data.Result.TotalCount}
                          </b>{' '}
                          {this.name.toLowerCase()}
                          {this.addedCount > 0 ? 's' : ''} added.
                        </div>
                      </div>
                    ),
                    duration: 5,
                  })
                  this.$emit('updateTableData')
                } else {
                  this.$notification.error({
                    message: 'Import',
                    description: h => (
                      <div>
                        <div>
                          There was an error while importing the{' '}
                          {this.name.toLowerCase()}.
                        </div>
                        <div>No record added in the database.</div>
                        <div>Please try again.</div>
                      </div>
                    ),
                  })
                  this.$emit('updateTableData')
                }
                data.name = this.name
                this.$root.$emit('socketMessage', data)
              } else {
                this.$emit('updateTableData')
              }
            } else if (data.Status === 'VALIDATIONERROR') {
              this.validationError = true
              this.$root.$emit('popupUpdation', false, true, null)
              if (data.Result && data.Result.length > 0) {
                this.updateList = []
                const list = _.get(data, 'Result', [])
                if (list.length > 0) {
                  list.forEach(element => {
                    const list = []
                    if (element.ValidationMessage) {
                      element.ValidationMessage = element.ValidationMessage.split(
                        '\n',
                      )
                      if (element.ValidationMessage.length > 0) {
                        element.ValidationMessage.forEach(element => {
                          list.push(element)
                        })
                      }
                    }
                    this.updateList.push({
                      description: element.Takeoff,
                      validationMessage: list,
                    })
                  })
                  this.visible = true
                }
                data.name = this.name
                this.$root.$emit('socketMessage', data)
              }
            } else {
              this.$root.$emit('popupUpdation', false, true, null)
              showNotification(
                'warning',
                'Import',
                _.get(data.Result, 'Message', ''),
              )
            }
          }
        } else if (data.Status === 'VALIDATIONERROR') {
          this.validationError = true
          this.$root.$emit('popupUpdation', false, true, null)
          if (data.Result && data.Result.length > 0) {
            this.updateList = []
            const list = _.get(data, 'Result', [])
            if (list.length > 0) {
              list.forEach(element => {
                const list = []
                if (element.ValidationMessage) {
                  element.ValidationMessage = element.ValidationMessage.split(
                    '\n',
                  )
                  if (element.ValidationMessage.length > 0) {
                    element.ValidationMessage.forEach(element => {
                      list.push(element)
                    })
                  }
                }
                this.updateList.push({
                  description: element.Takeoff,
                  validationMessage: list,
                })
              })
              this.visible = true
            }
            data.name = this.name
            this.$root.$emit('socketMessage', data)
          }
        } else {
          if (data.Status === 'SUCCESS') {
            if (data.Result && this.analysisTypeId !== 2) {
              this.updateList = []
              const list = _.get(data.Result, 'UpdateList', [])
              this.addedCount = _.get(data.Result, 'AddedCount', 0)
              if (list.length > 0) {
                list.forEach(element => {
                  this.updateList.push({
                    id: element.Id,
                    tenantName: element.TenantName,
                    suite: element.Suite,
                    tenantTypeId: element.TenantTypeId,
                    tenantType: element.TenantType,
                    tenantSF: element.TenantSF,
                  })
                })
                this.visible = true
              } else if (this.addedCount > 0) {
                this.$notification.success({
                  message: 'Import',
                  description: h => (
                    <div>
                      <div>
                        <b>
                          {this.addedCount} / {data.Result.TotalCount}
                        </b>{' '}
                        {this.name.toLowerCase()}
                        {this.addedCount > 0 ? 's' : ''} added.
                      </div>
                    </div>
                  ),
                  duration: 5,
                })
                this.$emit('updateTableData')
              } else {
                this.$notification.error({
                  message: 'Import',
                  description: h => (
                    <div>
                      <div>
                        There was an error while importing the{' '}
                        {this.name.toLowerCase()}.
                      </div>
                      <div>No record added in the database.</div>
                      <div>Please try again.</div>
                    </div>
                  ),
                })
                this.$emit('updateTableData')
              }
              data.name = this.name
              this.$root.$emit('socketMessage', data)
            } else {
              this.$emit('updateTableData')
            }
          } else {
            this.$emit('updateTableData')
            this.$root.$emit('popupUpdation', false, true, null)
            showNotification(
              'warning',
              'Import',
              _.get(data.Result, 'Message', ''),
            )
          }
        }
      } else if (data.EventType === socketEvents.error) {
        showNotification(
          'error',
          'Error',
          'There was an error while importing file. Please try again or contact administrator.',
        )
      }
    },
  },
}
